import router from 'vue-router'

export default function routerExceptionHandler(e:any) {
  if (!router.isNavigationFailure(e, router.NavigationFailureType.duplicated)) {
    throw e
  }}
